export const getSectionIdFromHash = (location: { hash?: string }) => {
  return location.hash && location.hash.split('#')[1];
};

export const createIdFromTitle = (title: string): string => {
  return title.split(' ').join('-').toLowerCase();
};
